import React, { useState } from 'react';
import s from './s.module.less';
import { Email } from 'constants/contact';
import { Modal } from 'antd';
import YouTubePlayer from 'components/YoutubePlayer';
import Image3 from './images/image3.png';

const ResourcesHelp = () => {
    const [play, setPlay] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    return (
        <div className={s.resourceHelpCard}>
            <Modal
                open={showPopup}
                width={550}
                className={s.modal}
                bodyStyle={{ height: 400 }}
                onCancel={() => {
                    setPlay(false);
                    setShowPopup(false);
                }}
                footer={null}
                destroyOnClose
            >
                <div className={s.playerBox}>
                    <div className={s.closeIcon} onClick={() => setShowPopup(false)} />
                    {
                        play ? (
                            <YouTubePlayer
                                playerWrapClassName={s.playerWrapper}
                                videoId="jy8oVJ2aCF4"
                                show
                            />
                        ) : (
                            <div className={s.player}>
                                <img className={s.playerImg} src={Image3} alt="" />
                                <div className={s.planBtn} onClick={() => setPlay(true)} />
                            </div>
                        )
                    }
                </div>
            </Modal>
            <div className={s.title}>Resources & help</div>
            {/* remove for product in 0530 */}
            {/* https://app.asana.com/1/1201608580743313/project/1203117087311346/task/1210413601913096?focus=true */}
            {/* <div className={s.cardItem}>
                <div className={s.cardContent}>
                    <div className={s.cardTitle}>
                        <span className={s.introIcons}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <path d="M6.44232 11.8333H9.55761M7.99996 2.5V3.16667M12.2426 4.25736L11.7712 4.72876M14 8.49997H13.3333M2.66667 8.49996H2M4.22873 4.72876L3.75732 4.25736M5.64294 10.857C4.34119 9.55529 4.34119 7.44474 5.64294 6.14299C6.94469 4.84125 9.05524 4.84125 10.357 6.14299C11.6587 7.44474 11.6587 9.55529 10.357 10.857L9.99226 11.2218C9.57033 11.6437 9.3333 12.2159 9.3333 12.8126V13.1667C9.3333 13.903 8.73634 14.5 7.99996 14.5C7.26359 14.5 6.66663 13.903 6.66663 13.1667V12.8126C6.66663 12.2159 6.4296 11.6437 6.00767 11.2218L5.64294 10.857Z" stroke="#00816B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <div className={s.titleText}>Intro to Kiwi Health</div>
                    </div>
                    <div className={`${s.cardDesc} ${s.cardDesc1}`}>
                        <div className={s.cardDescText}>
                            Get to know who we are and how we support your practice.
                        </div>
                        <a className={s.cardAction} onClick={() => setShowPopup(true)} target="_blank" rel="noopener noreferrer">
                            Watch video
                            <span className={s.arrow}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M13.3307 7.9974L2.66406 7.9974M8.66406 12.6641L13.3307 7.9974L8.66406 3.33073" stroke="#00816B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>
            </div> */}
            <div className={s.divider} />
            <div className={s.cardItem}>
                <div className={s.cardContent}>
                    <div className={s.cardTitle}>
                        <span className={s.introIcons}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <path d="M2 13.1632V7.21007C2 6.76427 2.2228 6.34796 2.59373 6.10067L7.2604 2.98956C7.70827 2.69098 8.29173 2.69098 8.7396 2.98956L13.4063 6.10067C13.7772 6.34796 14 6.76427 14 7.21007V13.1632M2 13.1632C2 13.8995 2.59695 14.4965 3.33333 14.4965H12.6667C13.403 14.4965 14 13.8995 14 13.1632M2 13.1632L6.5 10.1632M14 13.1632L9.5 10.1632M2 7.16316L6.5 10.1632M14 7.16316L9.5 10.1632M9.5 10.1632L8.7396 10.6701C8.29173 10.9687 7.70827 10.9687 7.2604 10.6701L6.5 10.1632" stroke="#00816B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <div className={s.titleText}>Need more help?</div>
                    </div>
                    <div className={s.cardDesc}>
                        Our support team is available via email at <a href={`mailto:${Email.support}`}>{Email.support}</a>.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResourcesHelp;
